import { useState } from 'react';
import classNames from "classnames";

import { pluralizeIfNecessary } from "@ascendnow/shared";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import { CoinsIcon, MoreIcon } from "../../AscIcons";

import styles from "./AscAppSubscriptionCard.module.scss";
import AscAdminAction from "../../AscAdminAction/AscAdminAction";
import AscParagraph from "../../AscTypography/AscParagraph/AscParagraph";
import AscRichTextViewer from "../../AscRichTextEditor/AscRichTextViewer/AscRichTextViewer";

export interface AscAppSubscriptionCardProps {
  id: string;
  title: string;
  logoUrl?: string;
  priceInCoins: number;
  description: string;
  onDelete: (appId: string) => void;
  onEdit: () => void;
}

export default function AscAppSubscriptionCard({
  id,
  title,
  logoUrl,
  priceInCoins,
  description,
  onDelete,
  onEdit,
}: AscAppSubscriptionCardProps) {
  const [showAction, setShowAction] = useState<boolean>(false);

  return (
    <AscGenericCard
      className={classNames(styles.ground)}
      imageClassName={styles.cardImage}
      title={title}
      coverImageUrl={logoUrl}
      tags={[
        <>
          <MoreIcon
            className={styles.moreIcon}
            data-testid={"asc-skill-card-more-icon"}
            onClick={() => setShowAction(!showAction)}
          />
          {showAction && (
            <AscAdminAction
              option1={"Edit"}
              option2={"Delete"}
              clickOption1={onEdit}
              clickOption2={() => onDelete(id)}
              className={styles.adminAction}
            />
          )}
        </>,
      ]}
      footer={
        <div className={styles.footerSection}>
          <CoinsIcon className={styles.icon} />
          <AscParagraph className={styles.priceCoins}>
            {priceInCoins} {pluralizeIfNecessary("coin", priceInCoins)}
          </AscParagraph>
        </div>
      }
    >
      <AscRichTextViewer
        className={styles.description}
        inferValue={description}
      />
    </AscGenericCard>
  );
}
